// Via het pakket-entrypoint, want een tweede kopie van Bootstrap registreert de data-api nog een keer.
import { Modal, Offcanvas, Tooltip } from 'bootstrap';

// Bootstrap draait hier als ES-module, dus er is geen globale namespace om een modal mee te openen.
window.dsOpenModal = (id) => {
    const element = document.getElementById(id);

    if (element) {
        Modal.getOrCreateInstance(element).show();
    }
};

window.dsCloseModal = (id) => {
    const element = document.getElementById(id);

    if (element) {
        Modal.getOrCreateInstance(element).hide();
    }
};

window.dsOpenDrawer = (id) => {
    const element = document.getElementById(id);

    if (element) {
        Offcanvas.getOrCreateInstance(element).show();
    }
};

// Twee-staps bevestiging: klik toont de prompt, Escape of blur annuleert.
document.addEventListener('click', (event) => {
    const start = event.target.closest('[data-ds-confirm-start]');

    if (start) {
        event.preventDefault();
        start.closest('[data-ds-confirm]')?.classList.add('is-confirming');

        return;
    }

    const cancel = event.target.closest('[data-ds-confirm-cancel]');

    if (cancel) {
        event.preventDefault();
        cancel.closest('[data-ds-confirm]')?.classList.remove('is-confirming');
    }
});

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
        return;
    }

    document.querySelectorAll('[data-ds-confirm].is-confirming').forEach((element) => {
        element.classList.remove('is-confirming');
    });
});

// Klikbare tabelrij: een klik op de rij activeert de primaire actie van die rij.
const DS_ROW_INTERACTIVE = 'a, button, input, select, textarea, label, [role="button"], [data-bs-toggle]';

document.addEventListener('click', (event) => {
    const row = event.target.closest('tr[data-ds-row-click]');

    if (!row || event.target.closest(DS_ROW_INTERACTIVE)) {
        return;
    }

    // Tekst selecteren mag geen navigatie triggeren.
    if (window.getSelection()?.toString()) {
        return;
    }

    row.querySelector('.ds-table__primary')?.click();
});

// Inklapbare card: de kop blijft staan, alleen de body en footer verdwijnen.
document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ds-card-toggle]');

    if (!toggle) {
        return;
    }

    const card = toggle.closest('.ds-card');

    if (card) {
        toggle.setAttribute('aria-expanded', card.classList.toggle('is-collapsed') ? 'false' : 'true');
    }
});

// Toasts. Eén regio voor de hele applicatie, aria-live zodat screenreaders meelezen.
const TOAST_ICONS = {
    info: 'fas fa-circle-info',
    success: 'fas fa-circle-check',
    warning: 'fas fa-triangle-exclamation',
    danger: 'fas fa-circle-exclamation',
};

function toastRegion() {
    let region = document.querySelector('.ds-toast-region');

    if (!region) {
        region = document.createElement('div');
        region.className = 'ds-toast-region';
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('aria-atomic', 'false');
        document.body.appendChild(region);
    }

    return region;
}

window.dsToast = function dsToast({ title = '', message = '', variant = 'info', duration = 5000 } = {}) {
    const element = document.createElement('div');

    element.className = `ds-toast ds-toast--${variant in TOAST_ICONS ? variant : 'info'}`;
    element.setAttribute('role', variant === 'danger' ? 'alert' : 'status');

    const icon = document.createElement('span');
    icon.className = `ds-toast__icon ${TOAST_ICONS[variant] ?? TOAST_ICONS.info}`;
    icon.setAttribute('aria-hidden', 'true');

    const content = document.createElement('div');
    content.className = 'ds-toast__content';

    if (title) {
        const titleElement = document.createElement('p');
        titleElement.className = 'ds-toast__title';
        titleElement.textContent = title;
        content.appendChild(titleElement);
    }

    if (message) {
        const messageElement = document.createElement('p');
        messageElement.className = 'ds-toast__message';
        messageElement.textContent = message;
        content.appendChild(messageElement);
    }

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ds-icon-btn ds-icon-btn--sm';
    close.setAttribute('aria-label', document.documentElement.lang === 'nl' ? 'Sluiten' : 'Close');
    close.innerHTML = '<span class="fas fa-xmark" aria-hidden="true"></span>';
    close.addEventListener('click', () => element.remove());

    element.append(icon, content, close);
    toastRegion().appendChild(element);

    if (duration > 0) {
        setTimeout(() => element.remove(), duration);
    }

    return element;
};

document.addEventListener('click', (event) => {
    event.target.closest('[data-ds-toast-dismiss]')?.closest('.ds-toast')?.remove();
});

// Toasts die de server meestuurt (flash messages) verdwijnen net als de JS-variant vanzelf.
document.querySelectorAll('.ds-toast[data-ds-toast-duration]').forEach((element) => {
    const duration = Number(element.dataset.dsToastDuration);

    if (duration > 0) {
        setTimeout(() => element.remove(), duration);
    }
});

// Livewire mag toasts sturen: $this->dispatch('ds-toast', variant: 'success', title: '…')
document.addEventListener('ds-toast', (event) => window.dsToast(event.detail ?? {}));

// Tooltips initialiseren, ook na een Livewire-update.
function initTooltips(root = document) {
    root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
        Tooltip.getOrCreateInstance(element, { customClass: 'ds-tooltip' });
    });
}

initTooltips();
document.addEventListener('livewire:navigated', () => initTooltips());

// Zoekveld wissen. Het input-event zorgt dat Livewire en wire:model meeluisteren.
document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-ds-search-clear]');

    if (!clear) {
        return;
    }

    const input = clear.closest('.ds-search')?.querySelector('.ds-input');

    if (!input) {
        return;
    }

    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
});

// Klikken op de lege ruimte van een tag-veld zet de cursor in het invoerveld.
document.addEventListener('click', (event) => {
    const wrapper = event.target.closest('[data-ds-tag-input]');

    if (wrapper && event.target === wrapper) {
        wrapper.querySelector('.ds-tag-input__input')?.focus();
    }
});

// Boomstructuur in- en uitklappen.
document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ds-tree-toggle]');

    if (!toggle) {
        return;
    }

    const item = toggle.closest('.ds-tree__item');
    const group = item?.querySelector(':scope > .ds-tree');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    item?.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if (group) {
        group.hidden = expanded;
    }
});

// De knoptekst van het categorieveld toont de gekozen tak.
document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.ds-category-select__input');
    const output = input?.closest('[data-ds-category-select]')?.querySelector('[data-ds-category-value]');

    if (!output) {
        return;
    }

    const name = input.parentElement.querySelector('.ds-category-select__name')?.textContent.trim();

    output.textContent = name || output.dataset.dsCategoryEmpty;
});

// Kenmerktype stuurt de rest van het formulier: keuzelijsten hebben waarden nodig,
// een ja/nee-kenmerk heeft geen eenheid.
function applyAttributeTypeRules(select) {
    const repeater = document.querySelector(select.dataset.dsAttributeRepeater ?? '');
    const unit = document.querySelector(select.dataset.dsAttributeUnit ?? '');

    if (repeater) {
        repeater.hidden = !['select', 'multiselect'].includes(select.value);
    }

    if (unit) {
        unit.disabled = select.value === 'boolean';
    }
}

function initAttributeTypes(root = document) {
    root.querySelectorAll('[data-ds-attribute-type]').forEach((select) => applyAttributeTypeRules(select));
}

document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-ds-attribute-type]');

    if (select) {
        applyAttributeTypeRules(select);
    }
});

document.addEventListener('DOMContentLoaded', () => initAttributeTypes());
document.addEventListener('livewire:navigated', () => initAttributeTypes());

// Drop zone: alleen de visuele staat, het uploaden zelf blijft aan de pagina.
['dragenter', 'dragover'].forEach((type) => {
    document.addEventListener(type, (event) => {
        const zone = event.target instanceof Element ? event.target.closest('[data-ds-file-upload]') : null;

        if (zone) {
            event.preventDefault();
            zone.classList.add('is-dragging');
        }
    });
});

['dragleave', 'drop'].forEach((type) => {
    document.addEventListener(type, (event) => {
        const zone = event.target instanceof Element ? event.target.closest('[data-ds-file-upload]') : null;

        if (!zone) {
            return;
        }

        zone.classList.remove('is-dragging');

        if (type === 'drop') {
            event.preventDefault();

            const input = zone.querySelector('input[type="file"]');

            if (input && event.dataTransfer?.files?.length) {
                input.files = event.dataTransfer.files;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });
});

// Een modal die eerder open stond onthoudt zijn scrollpositie; die hoort bovenaan te beginnen.
document.addEventListener('shown.bs.modal', (event) => {
    event.target.querySelector('.modal-body')?.scrollTo({ top: 0 });
});

// De actieve navigatielink is alleen visueel gemarkeerd; screenreaders hebben aria-current nodig.
function markCurrentNavLink() {
    document
        .querySelectorAll('.navbar-vertical .nav-link.active[href]')
        .forEach((link) => link.setAttribute('aria-current', 'page'));
}

document.addEventListener('DOMContentLoaded', markCurrentNavLink);
document.addEventListener('livewire:navigated', markCurrentNavLink);

